<template>
    <transition name="modal">
        <div id="addTalkgroupToUser" class="dialog-modal-mask">
            <div class="large-panel" @click.stop>
                <div class="dialog-title">
                    <div v-t="{ path: 'message.assign_client_setting_to_node', args: { CLIENT_SETTING_NAME: assignInfo.clientSettingName + ' ' } }">
                    </div>
                </div>
                <hr class="dialog-hr">
                <div class="dialog-body">
                    <table width=100% height=100% cellpadding=0 cellspacing=0>
                        <tr class="dialoginputfield">
                            <td colspan=2>
                                <div style="padding: 10px;">
                                    <el-form @submit.native.prevent="findNode()">
                                        <el-radio-group style="padding-left:10px" v-model="listType" fill="#5171cb">
                                            <el-radio-button :label="0"><span v-t="'message.action_select_by_list'"/></el-radio-button>
                                            <el-radio-button :label="1"><span v-t="'message.action_select_by_search'"/></el-radio-button>
                                        </el-radio-group>
                                        <el-input v-if="listType === 1" :placeholder="$t('message.place_holder_input_text')" v-model.trim="searchString" clearable class="object-search-select">
                                            <div slot="prepend"><span v-t="'message.item_layerId'"></span></div>
                                            <el-button slot="append" style="width: 100px;vertical-align:middle" native-type="submit" v-t="'message.action_search_items'"></el-button>
                                        </el-input>
                                    </el-form>
                                </div>
                            </td>
                        </tr>
                        <tr>
                            <td class="dialog-td">
                                <div class="inner-panel-header">
                                    <div class="inner-panel-title">
                                        <div class="inner-panel-title-left" v-t="'message.title_select_layer'">
                                        </div>
                                        <div v-if="listType === 0" class="inner-panel-title-right">
                                            <span v-t="'message.item_select_including_sub_node'"></span>
                                            <el-switch v-model="bulkSelect" active-color="#5171cb"></el-switch>
                                        </div>
                                        <div v-else class="inner-panel-title-right">
                                            <button class="transparent" @click="selectTagAll()" type="button"><span class="normal-command-text" v-t="'message.action_select_all'"></span></button>
                                        </div>
                                    </div>
                                </div>
                                <div v-if="listType === 0" class="inner-panel-dialog" style="height: calc(80vh - 240px);">
                                    <dialogtree
                                        class="dialog-tree"
                                        v-bind:initialData="appData.tenantList"
                                        @on-selectnode="handleOnSelectNode"
                                        selectionType=0
                                        ref="dialogTree">
                                    </dialogtree>
                                </div>
                                <div v-else class="inner-panel-dialog" style="height: calc(80vh - 240px);">
                                    <div class="foundObject-record" v-for="object in foundNodeList" @click="addTagWithConditionCheck(object.node.data)">
                                        <div class="foundObject">
                                            <span style="padding-left:10px;vertical-align:middle">{{ object.node.data.label }}</span>
                                        </div>
                                    </div>
                                </div>
                            </td>
                            <td class="dialog-td">
                                <div class="inner-panel-header">
                                    <div class="inner-panel-title">
                                        <div class="inner-panel-title-left" v-t="'message.title_editing_layer'">
                                        </div>
                                        <div class="inner-panel-title-right">
                                            <button class="transparent" @click="removeAllNodeTag()" type="button"><span class="normal-command-text" v-t="'message.action_delete_all'"></span></button>
                                        </div>
                                    </div>
                                </div>
                                <div id="selected-user" class="inner-panel-dialog" style="height: calc(80vh - 240px);">
                                    <div class="selected-item-field">
                                        <div class="default-message" v-if="!Object.keys(editTagList).length" v-html="$t('message.hint_add_layer_from_left_pane')">
                                        </div>
                                        <span v-for="tag in editTagList" v-bind:key="tag.id">
                                            <div class="userTag">
                                                <span class="userTag-name">{{ tag.label }}</span>
                                                <span class="closeTag" @click="removeNodeTag(tag)">×</span>
                                            </div>
                                        </span>
                                    </div>
                                </div>
                            </td>
                        </tr>
                    </table>
                </div>
                <hr class="dialog-hr">
                <div class="dialog-button-field">
                    <el-button class="dialog-cancel-button" type="button" @click="$emit('cancel')" v-t="'message.button_cancel'"></el-button>
                    <el-button class="dialog-ok-button" :disabled="disableSave" @click="saveUpdatedInfo()" v-t="'message.button_save'"></el-button>
                </div>
            </div>
        </div>
    </transition>
</template>

<script>
import Vue from 'vue';
import server from "@/components/ServerApi.js";
import DialogTree from "@/components/DialogTree.vue";
import commonUtil from '@/components/commonutil.js';
import constants from '@/components/constants.js';

const STATUS_SUCCESS = 0;
const STATUS_ALREADY_EXIST = -1;

export default {
    components: {
        dialogtree: DialogTree
    },

    props: {
        appData: {},
        tenantId: {
            type: Number,
            required: true
        },
        assignInfo: {
            clientSettingName: null,
            clientSettingId: null
        }
    },

    data() {
        return {
            rootNode: {
                tenantId: this.tenantId,
                id: 1,
                label: "ROOT-NODE",
                type: 0,
                isLeaf: false
            },
            scrollOnAction: false,
            editTagList: {},
            orgTagList: {},
            addTagList: {},
            removeTagList: {},
            foundNodeList: [],
            listType: 0,
            condition: "nodeId",
            searchString: null,
            bulkSelect: true,
            disableSave: true
        };
    },

    created: function() {
        this.disableSave = true;
        return this.getObjectListBySettingTemplateId();
    },

    updated: function() {
        if (this.scrollOnAction) {
            let obj = document.getElementById("selected-user");
            obj.scrollTop = obj.scrollHeight;
            this.scrollOnAction = false;
        }
    },

    methods: {
        findNode() {
            let param = {}
            if (this.condition === "nodeId") {
                param.name = this.searchString;
            }
            let self = this;
            server.post("/findnode", param)
                .then((res) => {
                    if (res.data.status === constants.STATUS_SUCCESS) {
                        if (res.data.nodeInfo.length === 0) {
                            self.foundNodeList = [];
                            commonUtil.notifyMessage(self,"Info",commonUtil.getMessageText(self.$i18n,"info_node_not_found"));
                            return;
                        }
                    } else {
                        self.foundNodeList = [];
                        commonUtil.notifyMessage(self,"Error",commonUtil.getMessageText(self.$i18n,"error_server_api").replace("{functionName}","findNode").replace("{code}",res.data.status));
                        return;
                    }
                    self.foundNodeList = [];
                    for (let objectInfo of res.data.nodeInfo) {
                        let object = { node : { data: null, parent: { data: null} } }
                        object.node.data = {
                            id: self.tenantId + "-" + objectInfo.id,
                            tenantId: self.tenantId,
                            type: constants.OBJECT_NODE,
                            objectId: objectInfo.id,
                            acl: objectInfo.acl,
                            label: objectInfo.name,
                        };
                        object.node.parent.data = {id: objectInfo.pid};
                        self.foundNodeList.push(object);
                    }
                })
                .catch( function ( error ) {
                    commonUtil.putExceptionErrorMessage(self, "findNode", error);
                    self.foundNodeList = [];
                });
        },
        getObjectListBySettingTemplateId() {
            let self = this;
            server.post('/getobjectlistbysettingtemplateid', {templateId: self.assignInfo.clientSettingId})
                .then((res) => {
                    switch (res.data.status) {
                        case constants.STATUS_SUCCESS:
                            break;
                        case constants.STATUS_ERROR_DENIED:
                            this.$emit('cancel');
                            return;
                        case constants.STATUS_ERROR_OBJECT_NOT_FOUND:
                            commonUtil.notifyMessage(self,"Error",commonUtil.getMessageText(self.$i18n,"error_client_setting_already_changed"));
                            return;
                        default:
                            commonUtil.notifyMessage(self,"Error",commonUtil.getMessageText(self.$i18n,"error_server_api").replace("{functionName}","getObjectListBySettingTemplateId").replace("{code}",res.data.status));
                            return;
                    }
                    for (let objectInfo of res.data.objectList) {
                        let key = self.tenantId + "-" + objectInfo.id;
                        let tagInfo = {
                            id: key,
                            tenantId: self.tenantId,
                            type: constants.OBJECT_NODE,
                            objectId: objectInfo.id,
                            acl: objectInfo.acl,
                            label: objectInfo.name,
                        };
                        Vue.set(self.editTagList, key, tagInfo);
                        Vue.set(self.orgTagList, key, tagInfo);
                    }
                })
                .catch( function ( error ) {
                    commonUtil.putExceptionErrorMessage(self, "getObjectListBySettingTemplateId", error);
                });
        },
        selectTagAll() {
            let addNodeCount = 0;
            for (let node of this.foundNodeList) {
                let tagInfo = node.node.data;
                if (this.checkConditionToAdd(tagInfo) === STATUS_SUCCESS) {
                    this.addTag(tagInfo);
                    addNodeCount ++;
                }
            }
            if (addNodeCount !== this.foundNodeList.length) {
                commonUtil.notifyMessage(this,"Warning",commonUtil.getMessageText(this.$i18n,"error_cannot_add_all_object").replace("{object}",commonUtil.getMessageText(this.$i18n,"item_layer")));
            }
        },
        addTagWithConditionCheck(tagInfo) {
            switch(this.checkConditionToAdd(tagInfo)) {
                case STATUS_SUCCESS:
                    this.addTag(tagInfo);
                    break;
                case STATUS_ALREADY_EXIST:
                    commonUtil.notifyMessage(this,"Info",commonUtil.getMessageText(this.$i18n,"info_layer_already_added"));
                    break;
            }
        },
        addTag(tagInfo) {
            this.scrollOnAction = true;
            Vue.set(this.editTagList, tagInfo.id , tagInfo);
            Vue.delete(this.removeTagList, tagInfo.id);
            if (!(tagInfo.id in this.orgTagList)) {
                Vue.set(this.addTagList, tagInfo.id, tagInfo);
            }
            this.disableSave = false;
            return true;
        },
        checkConditionToAdd(tagInfo) {
            if (tagInfo.id in this.editTagList) {
                return STATUS_ALREADY_EXIST;
            }

            return STATUS_SUCCESS;
        },
        handleOnSelectNode(data) {
            if (data.type === constants.OBJECT_NODE) {
                if (!this.bulkSelect) {
                    let key = data.tenantId + "-" + data.id;
                    if ((key in this.editTagList)) {
                        commonUtil.notifyMessage(this, "Info", commonUtil.getMessageText(this.$i18n, "info_layer_already_added"));
                        return;
                    }
                }
            } else {
                return;
            }

            let self = this;
            let tenantId = data.tenantId;
            let nodeId = data.id;
            if (self.bulkSelect) {
                server.post('/getmultipleinfo', {tenantId: tenantId, id: nodeId})
                    .then((res) => {
                        if (res.data.status >= 0) {
                            let countSuccess = 0;
                            let countAlready = 0;
                            let countNoWritable = 0;
                            for (let objectInfo of res.data.objectList) {
                                let acl = JSON.parse(objectInfo.acl)
                                if (acl.rw == null) {
                                    commonUtil.notifyMessage(self,"Warning", commonUtil.getMessageText(self.$i18n,"error_cannot_select_no_writable_layer"));
                                } else {
                                    for (let i = 0 ; i < acl.rw.length ; i++) {
                                        if (acl.rw[i].split("-")[1] == self.appData.loginUserObjectId) {
                                            let tagInfo = {
                                                id: tenantId + '-' + objectInfo.id,
                                                tenantId: tenantId,
                                                type: constants.OBJECT_NODE,
                                                objectId: objectInfo.id,
                                                acl: objectInfo.acl,
                                                label: objectInfo.name,
                                            };
                                            switch(this.checkConditionToAdd(tagInfo)) {
                                                case STATUS_SUCCESS:
                                                    this.addTag(tagInfo);
                                                    countSuccess++;
                                                    break;
                                                case STATUS_ALREADY_EXIST:
                                                    countAlready++;
                                                    break;
                                            }
                                            break;
                                        }
                                        if (i == acl.rw.length - 1) {
                                            countNoWritable++;
                                        }
                                    }
                                }
                            }
                            if (countAlready > 0 && countNoWritable > 0) {
                                commonUtil.notifyMessage(self,"Warning", commonUtil.getMessageText(self.$i18n,"info_layers_already_added").replace("{count}", countAlready) + commonUtil.getMessageText(self.$i18n,"error_cannot_select_no_writable_layers"));
                            } else if (countAlready > 0) {
                                commonUtil.notifyMessage(self,"Info", commonUtil.getMessageText(self.$i18n,"info_layers_already_added").replace("{count}", countAlready));
                            } else if (countNoWritable > 0) {
                                commonUtil.notifyMessage(self,"Warning", commonUtil.getMessageText(self.$i18n,"error_cannot_select_no_writable_layers"));
                            }
                        } else {
                            commonUtil.notifyMessage(self,"Error",commonUtil.getMessageText(self.$i18n,"error_server_api").replace("{functionName}","handleOnSelectNode").replace("{code}",res.data.status));
                        }
                    })
                    .catch( function ( error ) {
                        commonUtil.putExceptionErrorMessage(self, "handleOnSelectNode", error);
                    });
            } else {
                server.post('/getinfo', {tenantId: tenantId, id: nodeId})
                    .then((res) => {
                        if (res.data.status >= 0) {
                            let acl = JSON.parse(res.data.acl)
                            if (acl.rw == null) {
                                commonUtil.notifyMessage(self,"Warning", commonUtil.getMessageText(self.$i18n,"error_cannot_select_no_writable_layer"));
                                return;
                            } else {
                                for (let i = 0 ; i < acl.rw.length ; i++) {
                                    if (acl.rw[i].split("-")[1] == self.appData.loginUserObjectId) {
                                        break;
                                    }
                                    if (i == acl.rw.length - 1) {
                                        commonUtil.notifyMessage(self,"Warning", commonUtil.getMessageText(self.$i18n,"error_cannot_select_no_writable_layer"));
                                        return;
                                    }
                                }
                            }
                            let tagInfo = {
                                id: tenantId + '-' + nodeId,
                                tenantId: tenantId,
                                type: constants.OBJECT_NODE,
                                objectId: res.data.id,
                                acl: res.data.acl,
                                label: res.data.name,
                            };

                            self.addTagWithConditionCheck(tagInfo);
                        } else {
                            commonUtil.notifyMessage(self,"Error",commonUtil.getMessageText(self.$i18n,"error_server_api").replace("{functionName}","handleOnSelectNode").replace("{code}",res.data.status));
                        }
                    })
                    .catch( function ( error ) {
                        commonUtil.putExceptionErrorMessage(self, "handleOnSelectNode", error);
                    });
            }

        },
        removeNodeTag(tag) {
            let self = this;
            let acl = JSON.parse(tag.acl);
            if (acl.rw == null) {
                commonUtil.notifyMessage(self,"Warning", commonUtil.getMessageText(self.$i18n,"error_cannot_select_no_writable_layer"));
                return;
            } else {
                for (let i = 0 ; i< acl.rw.length ; i++) {
                    if (acl.rw[i].split("-")[1] == self.appData.loginUserObjectId) {
                        break;
                    }
                    if (i == acl.rw.length - 1) {
                        commonUtil.notifyMessage(self,"Warning", commonUtil.getMessageText(self.$i18n,"error_cannot_select_no_writable_layer"));
                        return;
                    }
                }

            }
            if ((tag.id in self.orgTagList)) {
                Vue.set(self.removeTagList, tag.id, tag);
            }
            Vue.delete(self.addTagList, tag.id);
            Vue.delete(self.editTagList, tag.id);
            self.disableSave = false;
        },
        removeAllNodeTag() {
            for (let key in this.editTagList) {
                if ((key in this.orgTagList)) {
                    let self = this;
                    let acl = JSON.parse(this.editTagList[key].acl)
                    if (acl.rw == null) {
                        commonUtil.notifyMessage(self,"Warning", commonUtil.getMessageText(self.$i18n,"error_cannot_remove_no_writable_some_layer"));
                        return;
                    } else {
                        for (let i = 0 ; i < acl.rw.length ; i++) {
                            if (acl.rw[i].split("-")[1] == self.appData.loginUserObjectId) {
                                break;
                            }
                            if (i == acl.rw.length - 1) {
                                commonUtil.notifyMessage(self,"Warning", commonUtil.getMessageText(self.$i18n,"error_cannot_remove_no_writable_some_layer"));
                                return;
                            }
                        }
                    }
                    Vue.set(this.removeTagList, key, this.editTagList[key]);
                }
            }
            this.editTagList = {};
            this.addTagList = {};
            this.disableSave = false;
        },
        saveUpdatedInfo() {
            this.$emit('save' , { removeTagList: this.removeTagList , addTagList: this.addTagList, newClientSettingId: this.assignInfo.clientSettingId });
        },
    }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.el-select-dropdown__item {
    font-size: 12px;
}
.el-select-dropdown__item selected {
    color: #5171cb;
}

.dialog-tree >>> .el-tree-node__content {
    min-height: 40px !important;
    height: auto !important;
    white-space: normal !important;
    word-break: break-all !important;
    text-align: justify;
}
.dialog-tree >>>.el-tree-node__expand-icon {
    padding: 0px 28px !important;
}

</style>

